<template>

    <!-- account tags -->
    <div class="bg-white overflow-hidden shadow rounded-lg relative pb-20">

        <div class="flex p-5 items-center">
            <h2 class="flex-1 text-lg font-medium leading-6 text-gray-900">
                Account Tags
            </h2>
        </div>

        <div class="px-5">
            <p class="text-sm text-gray-500 mb-4">
                Select tags for the account, giving access to products with those tags.
            </p>

            <ol class="grid grid-cols-2 lg:grid-cols-3 gap-4">
                <li v-for="tag in value.data.tags"
                    @click.prevent="value.toggleAccountTag(tag)"
                    class="status-box py-1 cursor-pointer hover:border-indigo-500 hover:text-indigo-500 flex items-center justify-center"
                    :class="{ 'border-indigo-500 text-indigo-500': value.isAccountTaggedAs(tag) }">
                    {{ tag.replace('_', ' ') }}
                </li>
            </ol>
        </div>


        <div class="flex items-center bg-gray-50 px-5 py-2 text-sm text-gray-400 absolute bottom-0 left-0 right-0">
            <p class="w-1/2">
                This account has access to <span class="font-medium text-gray-500">{{ value.data.account_product_count }}</span> products
            </p>
            <p class="flex w-1/2 justify-end text-xs items-center">

                <ConfirmationModal button_classes="btn-outline text-xs px-2 py-1" button_text="Show Products" @openModal="showAccountProducts" @closeModal="resetAccountProducts">
                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                        Account Products ({{ value.data.account_product_count }})
                    </h3>
                    <h4 class="text-lg leading-6 font-medium text-gray-400 mt-2">
                        {{ value.data.name }}
                    </h4>
                    <p class="mt-2 mb-4 text-sm">
                        These are the products this account has access to, based on tag and account product selection settings.
                    </p>
                    <div class="h-64 overflow-y-scroll" v-if="products">
                        <table class="w-full text-sm">
                            <tbody>
                                <tr class="colored-row" v-for="product in products">
                                    <td class="py-1">
                                        <span class="font-medium text-gray-500">{{ product.name }}</span><br>
                                    </td>
                                    <td class="py-1">
                                        <span class="text-xs">{{ product.sku }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <Loading :show_long_loading="false" message="Loading Account Products" v-else></Loading>
                </ConfirmationModal>

            </p>
        </div>
    </div>

</template>

<script>
import ConfirmationModal from "../Support/ConfirmationModal";
import Loading from "../Support/Loading";

export default {
    props: {
        value: {
            required: true
        }
    },
    name: "AccountTags",
    data() {
        return {
            products: false
        }
    },
    components: {
        ConfirmationModal,
        Loading
    },
    methods: {
        showAccountProducts() {
            let vm = this;

            this.resetAccountProducts();

            vm.value.getAllProductsAccountHasAccessTo().then(products => {
                vm.products = products;
            });
        },
        resetAccountProducts() {
            this.products = false;
        }
    }
}
</script>


